import React, { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

const ActivityChart = ({ monthlyStats = [] }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      // Destroy existing chart if any
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }

      // Extract data from monthlyStats
      const categories = monthlyStats.length > 0
        ? monthlyStats.map(m => m.month)
        : ['Ян', 'Фев', 'Мар', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Сеп', 'Окт', 'Ное', 'Дек'];
      const consultationsData = monthlyStats.length > 0
        ? monthlyStats.map(m => m.consultations)
        : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      const chartOptions = {
        chart: {
          height: 230,
          type: 'bar',
          stacked: false,
          toolbar: {
            show: false,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            borderRadius: 4,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 6,
          colors: ['transparent'],
        },
        series: [
          {
            name: 'Консултации',
            color: '#2E37A4',
            data: consultationsData,
          },
        ],
        xaxis: {
          categories: categories,
        },
        yaxis: {
          labels: {
            formatter: (val) => Math.round(val),
          },
        },
        legend: {
          show: false,
        },
      };

      chartInstanceRef.current = new ApexCharts(chartRef.current, chartOptions);
      chartInstanceRef.current.render();
    }

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
        chartInstanceRef.current = null;
      }
    };
  }, [monthlyStats]);

  return <div ref={chartRef}></div>;
};

export default ActivityChart;
